"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFieldWithLabel = exports.SelectField = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
var select_1 = require("@blueprintjs/select");
var lodash_1 = require("lodash");
var SelectFieldItem_1 = require("./SelectFieldItem");
var SimpleSelectField = select_1.Select.ofType();
var SelectField = (function (_super) {
    __extends(SelectField, _super);
    function SelectField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectField.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { id: props.id, className: "bp3-control-group", onClick: function (e) { return e.stopPropagation(); } },
            React.createElement(SimpleSelectField, { className: "pt-fill", onItemSelect: function (item) { return null; }, items: props.items.map(function (item) { return typeof item === 'string' ? ({ name: item }) : item; }), itemRenderer: function (item, _a) {
                    var index = _a.index;
                    return React.createElement(SelectFieldItem_1.SelectFieldItem, { key: index, item: item, value: props.value, onItemSelect: props.onItemSelect });
                }, filterable: false, popoverProps: { minimal: true, position: core_1.Position.BOTTOM }, disabled: props.disable },
                React.createElement(core_1.Button, { onClick: function (e) {
                        if (props.value && props.autoSelectItem && props.value === props.autoSelectItem.forValue) {
                            props.onItemSelect({ name: props.autoSelectItem.selectValue });
                        }
                    }, className: props.className ? props.className : undefined, text: props.value ? props.value : props.text ? props.text : undefined, rightIcon: "double-caret-vertical", disabled: props.disable }))));
    };
    return SelectField;
}(React.Component));
exports.SelectField = SelectField;
var InlineSelectField = function (props) { return (React.createElement("div", { id: props.id, className: "bp3-button-group bp3-fill" }, props.items.map(function (item, i) { return typeof item === 'string' ?
    React.createElement(core_1.Button, { key: i, intent: (0, lodash_1.isEqual)(item, props.value) ? core_1.Intent.PRIMARY : core_1.Intent.NONE, active: (0, lodash_1.isEqual)(item, props.value), text: item, onClick: function (e) { return props.onItemSelect({ name: item }); } }) :
    React.createElement("div", null, item.items.map(function (subItem, j) { return typeof subItem === 'string' ? (React.createElement(core_1.Button, { key: i + j, intent: (0, lodash_1.isEqual)(subItem, props.value) ? core_1.Intent.PRIMARY : core_1.Intent.NONE, active: (0, lodash_1.isEqual)(subItem, props.value), text: subItem, onClick: function () { return props.onItemSelect({ name: subItem }); } })) : (React.createElement(InlineSelectField, { id: "", items: subItem.items, value: props.value, onItemSelect: props.onItemSelect })); })); }))); };
var SelectFieldWithLabel = function (props) { return (React.createElement(core_1.FormGroup, { label: React.createElement("span", { className: "fw5 f5" }, props.label), helperText: props.helperText, labelFor: props.id, inline: props.inlineForm }, props.inline ?
    React.createElement(InlineSelectField, __assign({}, props))
    : React.createElement(SelectField, __assign({}, props)))); };
exports.SelectFieldWithLabel = SelectFieldWithLabel;
//# sourceMappingURL=SelectField.js.map